import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { loaders, TeamServiceWithTeam } from 'entities';

import { LabeledSelect } from 'components/Blocks';

import { listGet, sortByProperty } from 'utils/array';

interface ServicesProps {
  setService: (service: TeamServiceWithTeam) => void;
  service: TeamServiceWithTeam | undefined;
}

export function Services({ setService, service }: ServicesProps) {
  const { t } = useLang();

  const { loading, data } = loaders.teams.allServices.use({
    defaultValue: [],
  });

  const handleSelectChange = (serviceSelected: string) => {
    setService(listGet(data, serviceSelected)!);
  };

  const serviceOptions = useMemo(() => {
    const services = data.map(({ name, team, ...rest }) => ({
      ...rest,
      label: `${team.name} - ${name}`,
      teamName: team.name,
      serviceName: name,
    }));

    return sortByProperty(services, 'label');
  }, [data]);

  return (
    <LabeledSelect
      options={serviceOptions}
      value={service?.id || ''}
      onChangeDirect={handleSelectChange}
      label={t('quanti-quali-services') || ''}
      loading={loading}
      formatLabel={({ teamName, serviceName }) => (
        <span>
          <strong>{teamName}</strong> - {serviceName}
        </span>
      )}
    />
  );
}
